export const getPageTitleString = (title: string) => {
  if (title) {
    return `${title} | acehub`;
  }

  return 'acehub';
};
